import { Text, View } from '@react-pdf/renderer';

import { TargetFunction, TargetType } from '../../../../../store/reducers/workspace.reducer.ts';
import { greyP4 } from '../../../../../theme.ts';
import { getPhotometricSymbolReactPdf } from '../../../../../utils/photometricSymbolsPdf.tsx';
import styles from './SummaryStyles.ts';
import CheckMark from './svgs/CheckMark.tsx';
import FailMark from './svgs/FailMark.tsx';

interface SummaryProps {
  summaryData: {
    groupHeader: string;
    tableRowBody: {
      symbol: TargetFunction;
      type: TargetType;
      calculated: number;
      unit: string;
      target: number;
      check: boolean;
    }[];
  }[];
}

const Summary = ({ summaryData }: SummaryProps) => (
  <View style={{ width: 487, left: 74, color: greyP4, paddingTop: 30 }}>
    <Text style={styles.titleContent}>Summary</Text>

    <View style={styles.header}>
      <Text style={styles.reportTitle}>Results for the evaluation area</Text>
    </View>

    <View style={styles.headerDescription}>
      <Text>Results for the evaluation parameters</Text>
    </View>

    <View style={styles.table}>
      <View style={styles.tableHeader}>
        <Text style={[styles.headerCell, styles.headerColumn1]}> </Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Symbol</Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Calculated</Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Target</Text>
        <Text style={[styles.headerCell, styles.headerColumnCheck]}>Check</Text>
      </View>

      {summaryData &&
        summaryData.map((group, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={[styles.groupHeader]}>
              <Text>{group.groupHeader}</Text>
            </View>
            <View style={{ flex: 3.5 }}>
              {group.tableRowBody.map((row, rowIndex) => (
                <View style={styles.tableRowBody} key={rowIndex}>
                  <Text style={styles.symbolCell}>{getPhotometricSymbolReactPdf(row.symbol, row.type)}</Text>
                  <Text style={styles.regularCell}>
                    {row.calculated.toFixed(2)} {row.unit}
                  </Text>
                  <Text style={styles.regularCell}>
                    {row.target.toFixed(2)} {row.unit}
                  </Text>
                  <View style={styles.checkCell}>{row.check ? <CheckMark /> : <FailMark />}</View>
                </View>
              ))}
            </View>
          </View>
        ))}
    </View>
  </View>
);

export default Summary;
